import { render, staticRenderFns } from "./consulta-disciplina.html?vue&type=template&id=93225b62&"
import script from "./consulta-disciplina.js?vue&type=script&lang=js&"
export * from "./consulta-disciplina.js?vue&type=script&lang=js&"
import style0 from "./consulta-disciplina.css?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports